const router = {
  path: '/rnr/enterprise',
  name: 'RnrEnterprise',
  meta: { title: '企业实名认证', type: 'business' },
  component: () => import('@/components/Layout'),
  children: [
    {
      path: '/rnr/enterprise/card',
      name: 'RnrEnterpriseCard',
      meta: { title: '填写车卡信息', type: 'business' },
      component: () => import('@/views/rnr/enterprise/card')
    },
    {
      path: '/rnr/enterprise/cert',
      name: 'RnrEnterpriseCert',
      meta: { title: '填写企业信息', type: 'business' },
      component: () => import('@/views/rnr/enterprise/cert')
    },
    {
      path: '/rnr/enterprise/cert-image',
      name: 'RnrEnterpriseCertImage',
      meta: { title: '上传企业证件照片', type: 'business' },
      component: () => import('@/views/rnr/enterprise/cert-image')
    },
    {
      path: '/rnr/enterprise/user',
      name: 'RnrEnterpriseUser',
      meta: { title: '责任人身份信息', type: 'business' },
      component: () => import('@/views/rnr/enterprise/user')
    },
    {
      path: '/rnr/enterprise/paper',
      name: 'RnrEnterprisePaper',
      meta: { title: '责任人身份信息', type: 'business' },
      component: () => import('@/views/rnr/enterprise/paper')
    },
    {
      path: '/rnr/enterprise/idcard',
      name: 'RnrEnterpriseIdcard',
      meta: { title: '责任人身份信息', type: 'business' },
      component: () => import('@/views/rnr/enterprise/idcard')
    },
    {
      path: '/rnr/enterprise/file',
      name: 'RnrEnterpriseFile',
      meta: { title: '责任人身份信息', type: 'business' },
      component: () => import('@/views/rnr/enterprise/file')
    },
    {
      path: '/rnr/enterprise/notification',
      name: 'RnrEnterpriseNotification',
      // meta: { title: '责任告知书', type: 'business' },
      meta: { title: '实名认证隐私政策与责任告知书', type: 'business' },
      component: () => import('@/views/rnr/enterprise/notification')
    },
    {
      path: '/rnr/enterprise/agreement',
      name: 'RnrEnterpriseAgreement',
      meta: { title: '入网协议', type: 'business' },
      component: () => import('@/views/rnr/enterprise/agreement')
    },
    {
      path: '/rnr/enterprise/result',
      name: 'RnrEnterpriseResult',
      meta: { title: '校验结果', type: 'business' },
      component: () => import('@/views/rnr/enterprise/result')
    }
  ]
}

export default router



// WEBPACK FOOTER //
// ./src/router/enterprise-rnr.js